import { PredictiveETAActions } from "../action/predictiveETA-action";
import { PredictiveETAResponse } from "../types/PredictiveETAAddress";

export type PREDICTIVE_ETA_STATE = {
  loading: boolean;
  error: boolean;
  data: PredictiveETAResponse | null;
};

const initialState: PREDICTIVE_ETA_STATE = {
  loading: false,
  error: false,
  data: null,
};

export const predictiveETAReducer = (
  state: PREDICTIVE_ETA_STATE = initialState,
  action: PredictiveETAActions
) => {
  switch (action.type) {
    case "FETCH_PREDICTIVE_ETA":
      return { ...state, loading: true, error: false };
    case "FETCH_PREDICTIVE_ETA_SUCCESS":
      return { ...state, loading: false, error: false, data: action.payload };
    case "FETCH_PREDICTIVE_ETA_FAILED":
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};